import {
  Container,
  Typography,
  Box,
  Button,
  IconButton,
  Dialog,
  DialogContent,
  Tabs,
  Tab,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

// -- Ενημερωμένη Δομή Δεδομένων για Έργα --
const projectsData = [
  // Κατοικίες
  {
    image: '/images/project1.jpg',
    alt: 'Κατασκευή σπιτιού στην Τούζλα από τον πολιτικό μηχανικό Κρουσταλλά - Σύγχρονη κατοικία στη Βόρεια Ελλάδα',
    title: 'Κατοικία στην Τούζλα',
    category: 'Κατοικίες'
  },
  {
    image: '/images/project2.jpg',
    alt: 'Ανακαίνιση οικίας στα Κερδύλλια από τον μηχανικό Κρουσταλλά - Παραδοσιακή κατοικία στη Βόρεια Ελλάδα',
    title: 'Ανακαίνιση στα Κερδύλλια',
    category: 'Κατοικίες'
  },
  {
    image: '/images/project3.jpg',
    alt: 'Νέα Κατασκευή στις Σέρρες από τον μηχανικό Κρουσταλλά Αθανάσιο (mycivil)',
    title: 'Νεόδμητη Κατοικία στις Σέρρες',
    category: 'Κατοικίες'
  },
  // Κατασκευές (πρώην Υποδομές)
  {
    image: '/images/ipodomes1.jpg',
    alt: 'Έργο κατασκευής στη Βόρεια Ελλάδα από τον πολιτικό μηχανικό Κρουσταλλά - Γέφυρα',
    category: 'Κατασκευές'
  },
  {
    image: '/images/ipodomes2.jpg',
    alt: 'Έργο οδοποιίας στην περιοχή των Σερρών από τον μηχανικό Κρουσταλλά (mycivil)',
    category: 'Κατασκευές'
  },
  {
    image: '/images/ipodomes3.jpg',
    alt: 'Κατασκευή δικτύου αποχέτευσης στη Βόρεια Ελλάδα - Πολιτικός Μηχανικός Κρουσταλλάς',
    category: 'Κατασκευές'
  },
  {
    image: '/images/ipodomes4.jpg',
    alt: 'Έργο αντιπλημμυρικής προστασίας από το γραφείο Κρουσταλλά (mycivil)',
    category: 'Κατασκευές'
  },
  {
    image: '/images/ipodomes5.jpg',
    alt: 'Διαμόρφωση περιβάλλοντος χώρου σε δημόσιο έργο από τον μηχανικό Κρουσταλλά',
    category: 'Κατασκευές'
  },
  {
    image: '/images/ipodomes6.jpg',
    alt: 'Τεχνικό έργο κατασκευής στην Βόρεια Ελλάδα - Κρουσταλλάς Πολιτικός Μηχανικός',
    category: 'Κατασκευές'
  },
];

const Projects = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const categories = [...new Set(projectsData.map(p => p.category))]; // Λίστα κατηγοριών χωρίς 'Όλα'
  const [currentCategory, setCurrentCategory] = useState(categories[0] || ''); // Αρχική κατηγορία η πρώτη διαθέσιμη
  const [allImages, setAllImages] = useState(projectsData); // Λίστα για το lightbox

  // -- Λογική για Φιλτράρισμα και Lightbox --
  const filteredProjects = projectsData.filter(p => p.category === currentCategory);

  const handleOpenImage = (project) => {
    const globalIndex = projectsData.findIndex(p => p.image === project.image);
    setCurrentIndex(globalIndex);
    setAllImages(projectsData);
    setOpenDialog(true);
  };

  const handleNextLightboxImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % allImages.length);
  };

  const handlePrevLightboxImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + allImages.length) % allImages.length);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleCategoryChange = (event, newValue) => {
    setCurrentCategory(newValue);
  };

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography variant="h3" component="h1" align="center" gutterBottom sx={{ mb: 2 }}>
        Τα Έργα μας
      </Typography>

      {/* -- Tabs για Κατηγορίες (Χωρίς 'Όλα') -- */}
      {categories.length > 1 && ( // Εμφάνιση tabs μόνο αν υπάρχουν πάνω από μία κατηγορίες
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 5 }}>
          <Tabs
            value={currentCategory}
            onChange={handleCategoryChange}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            aria-label="Κατηγορίες Έργων"
          >
            {categories.map(category => (
              <Tab key={category} label={category} value={category} />
            ))}
          </Tabs>
        </Box>
      )}

      {/* -- Γκαλερί Έργων (Φιλτραρισμένη) -- */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
          gap: 3,
          mb: 6,
          px: { xs: 2, sm: 0 }
        }}
      >
        {filteredProjects.map((project) => (
          <Box
            key={project.image}
            onClick={() => handleOpenImage(project)}
            sx={{
              height: { xs: 200, sm: 250, md: 300 },
              borderRadius: 2,
              overflow: 'hidden',
              boxShadow: '0 4px 10px rgba(0,0,0,0.15)',
              cursor: 'pointer',
              transition: 'all 0.3s ease-in-out',
              '&:hover': {
                transform: 'scale(1.03)',
                boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
              },
              position: 'relative',
              // Προσθήκη στυλ για hover απευθείας στο γονικό Box
              '.image-title-overlay': { // Κλάση για το overlay
                opacity: 0,
                transition: 'opacity 0.3s ease-in-out',
              },
              '&:hover .image-title-overlay': {
                opacity: 1,
              },
            }}
          >
            <Box
              component="img"
              src={project.image}
              alt={project.alt}
              sx={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                display: 'block', // Για να μην υπάρχει κενό κάτω από την εικόνα
              }}
            />
            {/* Εμφάνιση τίτλου στο hover (μόνο αν υπάρχει τίτλος στο project) */}
            {project.title && (
              <Box
                className="image-title-overlay" // Προσθήκη κλάσης
                sx={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  padding: '12px',
                  color: 'white',
                  backgroundColor: 'rgba(0,0,0,0.6)',
                  textAlign: 'center',
                  pointerEvents: 'none',
                }}
              >
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                  {project.title}
                </Typography>
              </Box>
            )}
          </Box>
        ))}
      </Box>

      {/* -- Lightbox/Dialog -- */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="lg"
        fullWidth
      >
        <DialogContent sx={{ p: 0, bgcolor: 'black', position: 'relative' }}>
          <IconButton
            onClick={handleCloseDialog}
            sx={{
              position: 'absolute',
              top: 16,
              right: 16,
              color: 'white',
              bgcolor: 'rgba(0,0,0,0.4)',
              zIndex: 1000,
              '&:hover': { bgcolor: 'rgba(0,0,0,0.6)' }
            }}
          >
            <CloseIcon />
          </IconButton>

          <Box sx={{
            position: 'relative',
            height: { xs: '60vh', sm: '80vh' },
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            {allImages.length > 0 && (
              <Box
                component="img"
                src={allImages[currentIndex].image}
                alt={allImages[currentIndex].alt}
                sx={{
                  maxHeight: '100%',
                  maxWidth: '100%',
                  objectFit: 'contain',
                }}
              />
            )}

            {allImages.length > 1 && (
              <>
                <IconButton
                  onClick={handlePrevLightboxImage}
                  sx={{
                    position: 'absolute',
                    left: 16,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: 'white',
                    bgcolor: 'rgba(0,0,0,0.3)',
                    '&:hover': { bgcolor: 'rgba(0,0,0,0.6)' }
                  }}
                >
                  <ArrowBackIcon />
                </IconButton>

                <IconButton
                  onClick={handleNextLightboxImage}
                  sx={{
                    position: 'absolute',
                    right: 16,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: 'white',
                    bgcolor: 'rgba(0,0,0,0.3)',
                    '&:hover': { bgcolor: 'rgba(0,0,0,0.6)' }
                  }}
                >
                  <ArrowForwardIcon />
                </IconButton>
              </>
            )}
          </Box>
            {/* Εμφάνιση Τίτλου στο Lightbox (μόνο αν υπάρχει) */}
             {allImages.length > 0 && allImages[currentIndex].title && (
                 <Typography variant="caption" sx={{
                    position: 'absolute',
                    bottom: 10,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    color: 'rgba(255,255,255,0.8)',
                    bgcolor: 'rgba(0,0,0,0.5)',
                    p: '2px 8px',
                    borderRadius: 1,
                    fontSize: '0.8rem'
                 }}>
                    {allImages[currentIndex].title}
                 </Typography>
             )}
        </DialogContent>
      </Dialog>

      {/* -- CTA Section -- */}
       <Box sx={{ mt: 6, py: 6, bgcolor: 'grey.50', textAlign: 'center', borderRadius: 2 }}>
        <Typography variant="h4" component="h2" gutterBottom>
          Ενδιαφέρεστε για ένα παρόμοιο έργο;
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Επικοινωνήστε μαζί μας για να συζητήσουμε τις ανάγκες του έργου σας
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          component={RouterLink}
          to="/contact"
          sx={{
            px: 4,
            py: 1,
            borderRadius: 2,
            fontWeight: 'bold',
          }}
        >
          Επικοινωνία
        </Button>
      </Box>
    </Container>
  );
};

export default Projects; 